<dx-box
    #vendorDisbursementsCheckBox
    height="100%"
    width="100%"
    direction="col"
    [elementAttr]="{ id: 'vendorDisbursementsCheckBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1" *ngIf="vendorDisbursements">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'VENDOR_DISBURSEMENTS_SEARCH_GRID' }"
            [dataSource]="vendorDisbursements"
        >
            <dx-data-grid width="100%" height="100%" [dataSource]="vendorDisbursements">
                <dxo-search-panel [text]="searchText"></dxo-search-panel>
                <dxi-column dataField="vendor" dataType="string" caption="Vendor"></dxi-column>
                <dxi-column
                    dataField="paymentNumber"
                    dataType="string"
                    caption="Check"
                    cellTemplate="checkTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="paymentAmount"
                    dataType="number"
                    caption="Payment Amount"
                    [format]="currencyFormat"
                ></dxi-column>
                <dxi-column
                    dataField="paymentDate"
                    dataType="date"
                    caption="Payment Date"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column dataField="paymentMethod" dataType="string" caption="Payment Method"></dxi-column>
                <dxi-column
                    dataField="cleared"
                    dataType="boolean"
                    caption="Cleared"
                    cellTemplate="clearedTemplate"
                    [width]="70"
                ></dxi-column>
                <dxi-column
                    dataField="dateCleared"
                    dataType="date"
                    caption="Date Cleared"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    cellTemplate="communityTemplate"
                ></dxi-column>
                <dxi-column dataField="location" dataType="string" dataType="string" caption="Location"></dxi-column>
                <dxi-column dataField="managementCompany" dataType="string" caption="Management Company"></dxi-column>
                <dxi-column dataField="bankAccount" dataType="string" caption="Bank Account"></dxi-column>
                <dxi-column dataField="bankName" dataType="string" caption="Bank Name"></dxi-column>
                <dxi-column dataField="accountNumber" dataType="string" caption="Account Number"></dxi-column>

                <div *dxTemplate="let cell of 'checkTemplate'">
                    <app-hyperlink-creator
                        [displayText]="cell.value"
                        (onLinkClick)="onCheckClick(cell.data)"
                    ></app-hyperlink-creator>
                </div>

                <div *dxTemplate="let cell of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let cell of 'clearedTemplate'">
                    <i [ngClass]="getCheckMarkIcon(cell.data.cleared)"></i>
                </div>

                <dxo-summary>
                    <dxi-group-item
                        column="accountNumber"
                        summaryType="count"
                        displayFormat="Count = {0}"
                    ></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#vendorDisbursementsCheckBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-ap-payment-details
    *ngIf="showPaymentDetail"
    [visible]="showPaymentDetail"
    [apPaymentParam]="apPaymentDetailParam"
    (onAPPaymentClose)="showPaymentDetail = false"
></app-ap-payment-details>
